class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.updateMinimumWarning();
    if (this.header) this.header.reveal();
    this.open();
  }

  updateMinimumWarning() {
    const MIN = parseInt(this.dataset.minItems || '8', 10);
    const warningEl = document.getElementById('cart-notification-minimum-warning');
    const warningText = document.getElementById('cart-notification-minimum-text');
    const form = document.getElementById('cart-notification-form');
    if (!warningEl || !form) return;

    const bubble = document.querySelector('#cart-icon-bubble [aria-hidden="true"]');
    const count = bubble ? (parseInt(bubble.textContent, 10) || 0) : 0;
    const needed = MIN - count;

    if (count > 0 && count < MIN) {
      const strings = window.cartMinimumStrings || {};
      const msg = needed === 1
        ? (strings.one || 'Add 1 more item (minimum 8)')
        : (strings.other || 'Add ' + needed + ' more items (minimum 8)').replace('{{ count }}', needed);
      if (warningText) warningText.textContent = msg;
      warningEl.hidden = false;
      form.querySelector('button').disabled = true;
    } else {
      warningEl.hidden = true;
      form.querySelector('button').disabled = false;
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
